// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* #google_translate_element {
  background: #ffffff;
  border-radius: 12px;
  padding: 10px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  display: inline-block;
} */

.VIpgJd-ZVi9od-ORHb-OEVmcd {
  /* display: none !important; */
    opacity: 0.8;
    height: 30px !important;
}
body{
    top: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/components/translator.css"],"names":[],"mappings":"AAAA;;;;;;GAMG;;AAEH;EACE,8BAA8B;IAC5B,YAAY;IACZ,uBAAuB;AAC3B;AACA;IACI,iBAAiB;AACrB","sourcesContent":["/* #google_translate_element {\n  background: #ffffff;\n  border-radius: 12px;\n  padding: 10px;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n  display: inline-block;\n} */\n\n.VIpgJd-ZVi9od-ORHb-OEVmcd {\n  /* display: none !important; */\n    opacity: 0.8;\n    height: 30px !important;\n}\nbody{\n    top: 0 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
